import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './extensions/login/login.component';
import { Authguard } from './modules/shared/interceptors/authguard.service';
import { ResetPasswordComponent } from './extensions/reset-password/reset-password.component';
import { AwsRedirectionComponent } from './extensions/aws-redirection/aws-redirection.component';
import { AwsRedirectionFailedComponent } from './extensions/aws-redirection-failed/aws-redirection-failed.component';
import { SignUpComponent } from './extensions/sign-up/sign-up.component';
import { ONBOARDING_METHODS } from './modules/shared/constants/api-constants';
import { EventsSignUpComponent } from './extensions/events-sign-up/events-sign-up.component';
import { SocialMediaSignUpComponent } from './extensions/social-media-sign-up/social-media-sign-up.component';
import { WhatsappSignUpComponent } from './extensions/whatsapp-sign-up/whatsapp-sign-up.component';
import { PersonalizedItineraryFormComponent } from './extensions/personalized-itinerary-form/personalized-itinerary-form.component';
import { HomePageTgTourismComponent } from './extensions/home-page-tg-tourism/home-page-tg-tourism.component';
import { TgItineraryFormComponent } from './extensions/tg-itinerary-form/tg-itinerary-form.component';
import { MapviewComponent } from './extensions/mapview/mapview.component';
import { UserTripDetailsComponent } from './extensions/user-trip-details/user-trip-details.component';
import { UserPreferencesComponent } from './extensions/user-preferences/user-preferences.component';
import { AiRouteCraftComponent } from './extensions/ai-route-craft/ai-route-craft.component';
import { UserHotelsSelectionComponent } from './extensions/user-hotels-selection/user-hotels-selection.component';
import { UserVehiclesSelectionComponent } from './extensions/user-vehicles-selection/user-vehicles-selection.component';
import { UserTripReviewComponent } from './extensions/user-trip-review/user-trip-review.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./modules/master-layout/master-layout.module').then(m => m.MasterLayoutModule),
    canActivateChild: [Authguard]
  },
  { path: 'login', component: LoginComponent },
  { path: 'sign-up', component: SignUpComponent, data: { onboardingMethod: ONBOARDING_METHODS.Website } },
  { path: 'events', component: EventsSignUpComponent, data: { onboardingMethod: ONBOARDING_METHODS.Events } },
  { path: 'social', component: SocialMediaSignUpComponent, data: { onboardingMethod: ONBOARDING_METHODS.Social } },
  { path: 'whatsapp', component: WhatsappSignUpComponent, data: { onboardingMethod: ONBOARDING_METHODS.WhatsApp } },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'verify', component: AwsRedirectionComponent },
  { path: 'pi', component: PersonalizedItineraryFormComponent },
  { path: 'home-page-tg', component: HomePageTgTourismComponent },
  { path: 'tg-itinerary-form', component: TgItineraryFormComponent },
  { path: 'verification-failed', component: AwsRedirectionFailedComponent },
  { path: 'mapview', component: MapviewComponent },
  { path: 'trip-details', component: UserTripDetailsComponent },
  { path: 'user-preferences', component: UserPreferencesComponent },
  { path: 'ai-route-craft', component: AiRouteCraftComponent},
  { path: 'hotel-selection', component: UserHotelsSelectionComponent},
  { path: 'vehicles-selection', component: UserVehiclesSelectionComponent},
  { path: 'user-trip-review', component: UserTripReviewComponent},
  { path: '**', redirectTo: '' },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
